<ng-container *ngIf="!hide">
    <div class="search--customer">
        <label class="required" title="* Required" *ngIf="label && required">Search {{label}}</label>
        <label *ngIf="label && !required">Search {{label}}</label>
        <div class="search--customer__group" *ngIf="!results">
            <div class="search--customer__input">
                <search-criteria [context]="2" [placeholder]="placeholder" (onResultsReceived)="receiveResults($event)"></search-criteria>
            </div>
            <div class="search--customer__advanced" *ngIf="!autoHideSearch || (!(results && results.length) && autoHideSearch)">
                <a href="javascript:void(0)" (click)="popupAdvancedSearchModal()">Advanced</a>
            </div>
        </div>
    </div>

    <search-results [context]="2" [results]="results" [readOnly]="readOnly" (onItemRemoved)="onRemove()" (onItemSelected)="onSelect($event)" *ngIf="results"></search-results>
</ng-container>
